import { jsLocalDateToYMD } from '@/utils/date';
import { CalendarDate } from '@/utils/platform-api/__generated__/graphql';
import { addDays, isAfter, isBefore, parseISO } from 'date-fns';

export function setNextUnavailable(
  calendarDatesMap: Record<string, CalendarDate> | undefined,
  selectedDates: any
) {
  if (!selectedDates) {
    console.warn('selectedDates missing/invalid');
    return undefined;
  }
  if (typeof selectedDates.from !== 'object' || !selectedDates.from) {
    return undefined;
  }
  let nextUnavailableDate =
    calendarDatesMap?.[jsLocalDateToYMD(selectedDates.from)];
  while (nextUnavailableDate && nextUnavailableDate.available) {
    // Careful use of toISOString to avoid DST issues
    const nextUnavailableDateYMD = addDays(
      parseISO(nextUnavailableDate.cal_date),
      1
    )
      .toISOString()
      .split('T')[0];
    nextUnavailableDate =
      calendarDatesMap?.[nextUnavailableDateYMD] || undefined;
  }
  return nextUnavailableDate;
}

export function setPriorUnavailable(
  calendarDatesMap: Record<string, CalendarDate> | undefined,
  selectedDates: any
) {
  if (!selectedDates) {
    console.warn('selectedDates missing/invalid');
    return undefined;
  }
  if (typeof selectedDates.from !== 'object' || !selectedDates.from) {
    return undefined;
  }
  let priorUnavailableDate =
    calendarDatesMap?.[jsLocalDateToYMD(selectedDates.from)];
  while (priorUnavailableDate && priorUnavailableDate.available) {
    // Careful use of toISOString to avoid DST issues
    const priorUnavailableDateYMD = addDays(
      parseISO(priorUnavailableDate.cal_date),
      -1
    )
      .toISOString()
      .split('T')[0];
    priorUnavailableDate =
      calendarDatesMap?.[priorUnavailableDateYMD] || undefined;
  }
  return priorUnavailableDate;
}

export function checkAfterNextUnavailable(
  nextUnavailableDate: CalendarDate | undefined,
  props: any
) {
  if (nextUnavailableDate) {
    const adjusted = addDays(parseISO(nextUnavailableDate.cal_date), 1);
    return isAfter(props.day.date, adjusted);
  }
  return undefined;
}

export function checkBeforePriorUnavailable(
  priorUnavailableDate: CalendarDate | undefined,
  props: any
) {
  if (priorUnavailableDate) {
    return isBefore(props.day.date, parseISO(priorUnavailableDate.cal_date));
  }
  return undefined;
}
